import styled from 'styled-components';

import { Heading as UnstyledTitle } from '@glowforge/gf-styled/components/typography';
import HorizontalScroll from '@glowforge/gf-styled/components/horizontal-scroll';
import { GridContainerWithBackground } from '@glowforge/gf-styled/components/grid-container';

export const TextWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 0 24px 0;
  &&&& svg {
    stroke: ${(props) => props.theme.colors.plasma.lightest};
  }

  @media ${(props) => props.theme.queries.desktopAndUp} {
    flex-direction: row;
    padding: 64px 0;
  }
`;

export const Title = styled(UnstyledTitle)`
  text-align: center;
  padding-top: 12px;
  --font-weight: 400; // per design spec, I think.
  color: ${(props) => props.theme.colors.plasma.lightest};
  @media ${(props) => props.theme.queries.desktopAndUp} {
    padding-top: 0;
    padding-left: 12px;
  }
`;

export const CardsWrapper = styled(HorizontalScroll)`
  grid-column: full-start / full-end;
  padding: 0;
`;

export const Wrapper = styled(GridContainerWithBackground)`
  grid-column: full-start / full-end;
  padding-bottom: 64px;
  & svg {
    stroke: ${(props) => props.theme.colors.white};
  }
`;
